import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { DefaultCurrencyPerLocation } from "@bitwarden/web-vault/app/models/types/location-currency.types";

// getLocationFromCurrency() only ever resolves to a UserLocationType (it falls back to
// DefaultSystemLocation, never empty), so this set is exhaustive, not a subset guess. These
// are the only codes scripts/generate-flag-symbols.js duplicates into sprite.svg — see
// SPRITE_DUPLICATE_CODES there — so this renderer never pays for a second flags.svg fetch.
const SPRITE_FLAG_IDS = new Set(
  Object.keys(DefaultCurrencyPerLocation).map((code) => code.toLowerCase()),
);

@Component({
  selector: "app-symbol-country-renderer",
  templateUrl: "./symbol-country-renderer.component.html",
})
export class SymbolCountryRendererComponent implements ICellRendererAngularComp {
  country: string = "";

  agInit(params: ICellRendererParams): void {
    this.setData(params);
  }

  setData(params: ICellRendererParams): void {
    const countryCode = params.data?.country?.toLowerCase() || "";
    this.country = countryCode;
  }

  refresh(params: ICellRendererParams): boolean {
    this.setData(params);
    return true;
  }

  // Resolves to a sprite.svg <symbol> id, or "" when the code has no duplicated flag artwork
  // — renders no flag rather than a dangling <use>. Mirrors
  // DropdownSearchComponent.flagSymbolId(), which guards the flags.svg reference the same way.
  flagSymbolId(): string {
    return SPRITE_FLAG_IDS.has(this.country) ? this.country : "";
  }
}
